import { getApiErrorCode } from "@gettactic/helpers";
import { dedicatedUserErrorMessage } from "@/lib/dedicated-user-errors";

/** A readable reason a resource save was refused. */
export const describeResourceSaveError = (error: unknown): string => {
  const code = getApiErrorCode(error);
  switch (code) {
    case "zone_manager_cannot_move":
      return "Only an admin can move this to another floor, zone or office.";
    case "cannot_manage_resource":
      return "You can't change this any more: it isn't in a zone you manage.";
    case "capacity_below_dedicated_users":
      return dedicatedUserErrorMessage(code);
    default:
      return "Sorry we couldn't save the changes";
  }
};
